import { PlatformStreamSettings } from '@widgets/PlatformStreamSettings';

/**
 * Settings page — global preferences and platform connection configuration.
 *
 * Platform connection settings (RTMP URL, stream key, Save to Server) live here.
 * Platform enable/disable toggles ("STREAM PLATFORMS") live on the Preview tab
 * next to the Start Streaming button, where the user is actually going live.
 */
export function SettingsPage() {
  return (
    <div className="h-full overflow-y-auto p-5">
      <div className="max-w-xl space-y-4 text-sm text-text-secondary">
          <PlatformStreamSettings />
      </div>
    </div>
  );
}
